export default __webpack_public_path__ + "static/media/googleLogo.ca31a14d.jpg";